import React, { useEffect, useState } from "react";
import ConsumoController from "../../controllers/ConsumoController";
import { UseContextApp } from "../../Global/Context/appContext";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
import { Link, useLocation } from "react-router-dom";
import BreadCrumbsGeneric from "../../components/Nav/BreadCrumbsGeneric";
import { colors } from "../../propsType/Colors";

function Bills() {
  const { saldo } = ConsumoController();
  const [{ user }] = UseContextApp();
  const [dataBills, setDataBills] = useState([""]);

  //Te indica en que rutas estas actualmente
  const location = useLocation();
  const pathName = location.pathname;
  
  const [loading, setLoading] = useState(false);

  //Funcion que obtiene las cuentas a pagar 
  const getSaldo = async () => {
    setLoading(true);
    const res = await saldo(user);
    if (res) {
      setDataBills(res);
      setLoading(false);
    } else {
    }
  };
  useEffect(() => {
    getSaldo();
  }, []);

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        {loading ? (
          <>
            <div className="w-full h-screen flex justify-center items-center ">
              <Spinner title={"Espere..."} />
            </div>
          </>
        ) : (
          <>
            <div className="flex lg:w-full gap-5 px-4 overflow-auto flex-col">
              {/*   Recibe la navegacion que te indica en que ruta estas */}
              <BreadCrumbsGeneric locations={pathName} />
              <div className="bg-white rounded-[10px] py-5 lg:py-0 border-b border-gray-200 lg:px-0 px-6">
                <div className=" py-6 px-6 sm:px-6">
                  <div className="py-2 text-2xl font-medium ">
                    Saldo              
                  </div>
                  <div className=" text-lg font-regular ">
                    Selecciona el número de cuenta en la que deseas pagar o domiciliar.       

                  </div>
                </div>
                <div className="!m-0 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white rounded-[10px] gap-5 shadow-lg  mt-5 ">
                  {dataBills?.lCuenta?.length > 0 ? (
                    <>
                      <div className="bg-white shadow overflow-hidden sm:rounded-md">
                        <ul role="list" className="divide-y divide-gray-200">
                          <div className=" hidden px-4 py-2 md:grid gap-4 lg:grid-cols-5 sm:px-6 border-b border-gray-200">
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Número de Cuenta
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Servicios
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Saldo en Bolívares
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Saldo en Dólares
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            ></div>
                          </div>
                          {dataBills?.lCuenta.map((cuenta, index) => (
                            <Link
                              key={index}
                              state={{ data: cuenta }}
                              to={"/cuenta/pagos"}
                              className="group"
                            >
                              <li key={cuenta.id}>
                                <div className="px-4 py-4 grid gap-4 lg:grid-cols-5 items-center sm:px-6 group-hover:bg-gray-50">
                                  <div
                                    className={`text-sm text-start justify-center flex items-end font-medium text-[${colors.lightBlue}]  truncate`}
                                  >
                                    {cuenta.nroCuenta}
                                  </div>
                                  <div className="text-sm text-gray-500 text-center justify-center flex items-end font-medium   ">
                                    {cuenta.servicios.length > 20 ? (
                                      <>
                                        <div
                                          className="button cursor-pointer decoration-txt"
                                          data-tooltip={cuenta.servicios}
                                        >
                                          {cuenta.servicios.substr(0, 20)}...
                                        </div>
                                      </>
                                    ) : (
                                      <>{cuenta.servicios}</>
                                    )}
                                  </div>
                                  <div>
                                    <div className="flex items-center gap-2 flex-col text-sm text-gray-500">
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Saldo en Bolívares
                                      </div>
                                      <div className="w-[50%]">
                                        <div
                                          className={`${parseFloat(cuenta.deudaTotalVEF) <=
                                            0
                                            ? "bg-green-100"
                                            : parseFloat(
                                              cuenta.deudaTotalVEF
                                            ) === 0
                                              ? "bg-gray-100"
                                              : "bg-red-100"
                                            } font-bold  w-full grid grid-cols-2 place-items-center py-[2px] gap=[8px] rounded-full`}
                                        >
                                          <p className="!text-black col-span-1 text-[16px] ">BS</p>

                                          <p
                                            className={parseFloat(cuenta.deudaTotalVEF) <= 0 ? "text-green-800 col-span-1 pr-6 " : parseFloat(cuenta.deudaTotalVEF) === 0
                                              ? "text-gray-800 col-span-1 pr-6 "
                                              : "text-red-800 col-span-1 pr-6 "
                                            }
                                          >
                                            {(parseFloat(
                                              cuenta.deudaTotalVEF
                                            ).toFixed(2))}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className=" flex w-full items-end justify-center">
                                    <div className="font-medium text-[14px] md:hidden block  ">
                                      Saldo en Dólares
                                    </div>
                                    <div className="w-[50%]">
                                      <div
                                        className={`${parseFloat(cuenta.deudaTotalUSD) <= 0
                                          ? "bg-green-100"
                                          : parseFloat(
                                            cuenta.deudaTotalUSD
                                          ) === 0
                                            ? "bg-gray-100"
                                            : "bg-red-100"
                                          } font-bold grid grid-cols-2 place-items-center gap-2 pb-[1px] w-full gap=[8px] rounded-full`}
                                      >
                                        <p className="!text-black col-span-1 ">USD</p>
                                        <p
                                          className={
                                            parseFloat(cuenta.deudaTotalUSD) <= 0 ? "text-green-800 col-span-1 pr-5 " : parseFloat(cuenta.deudaTotalUSD) === 0
                                              ? "text-gray-800 col-span-1 pr-5"
                                              : "text-red-800 col-span-1 pr-5"
                                          }
                                        >
                                          {(parseFloat(
                                            cuenta.deudaTotalUSD
                                          ).toFixed(2))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex items-end w-full justify-around ">
                                    {/*    Se manda el numero de cuenta por paramtros para completar el metodo de pago */}
                                    <Link
                                      state={{ data: cuenta }}

                                      to={"/cuenta/pagos"}
                                      className={`hover:text-blue-950 focus:border-blue-900 font-medium text-[${colors.lightBlue}]`}                        

                                    >
                                      Realizar Pago
                                    </Link>
                                    <Link
                                      state={{ data: cuenta }}
                                      to={"/cuenta/domiciliacion"}
                                      className={`hover:text-blue-950 focus:border-blue-900 font-medium text-[${colors.lightBlue}]`}
                                    >
                                      Domiciliar
                                    </Link>
                                    
                                  </div>
                                 
                                 
                                </div>
                              </li>
                            </Link>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="h-[20vh] flex justify-center items-center text-[1.3rem] font-semibold  ">
                        No posees servicios activos
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Bills;
